import DOMPurify from 'dompurify';

export function sanitizeHtml(dirty: string): string {
	return DOMPurify.sanitize(dirty, { USE_PROFILES: { html: true } });
}
